import { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { useI18nContext } from "@hopper-b2b/i18n";
import { HOTELS_SEARCH_PATH } from "@overrides/utilities";

export const useHomePageHotelSearch = () => {
  const { t } = useI18nContext();

  const navigate = useNavigate();

  const handleMobileRedirect = useCallback(() => {
    navigate(HOTELS_SEARCH_PATH);
  }, [navigate]);

  return {
    context: {},
    handlers: {
      handleMobileRedirect,
    },
    text: {
      mobileButtonLabel: t("core-hotels.search.startSearch"),
    },
  };
};
